export default function PHP_getprotobynumber() {
  return (
    <div>
      <h1>PHP_getprotobynumber</h1>
    </div>
  );
}
